class AgCoverflow extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll("[data-ag-card]"));
    this.prevBtn = this.querySelector("[data-ag-prev]");
    this.nextBtn = this.querySelector("[data-ag-next]");
    this.index = this.cards.findIndex((card) => card.classList.contains("is-active"));
    if (this.index < 0) this.index = 0;
    this.prevBtn?.addEventListener("click", () => this.step(-1));
    this.nextBtn?.addEventListener("click", () => this.step(1));
    this.cards.forEach((card, idx) => {
      card.addEventListener("click", (event) => {
        if (idx === this.index) return;
        event.preventDefault();
        this.index = idx;
        this.render();
      });
    });
    this.render();
  }

  step(delta) {
    if (!this.cards.length) return;
    this.index = (this.index + delta + this.cards.length) % this.cards.length;
    this.render();
  }

  render() {
    const total = this.cards.length;
    this.cards.forEach((card, idx) => {
      card.classList.remove("is-active", "is-prev-1", "is-prev-2", "is-next-1", "is-next-2");
      const offset = (idx - this.index + total) % total;
      const wrapped = offset > total / 2 ? offset - total : offset;
      if (wrapped === 0) card.classList.add("is-active");
      else if (wrapped === -1) card.classList.add("is-prev-1");
      else if (wrapped === -2) card.classList.add("is-prev-2");
      else if (wrapped === 1) card.classList.add("is-next-1");
      else if (wrapped === 2) card.classList.add("is-next-2");
    });
  }
}

if (!customElements.get("ag-coverflow")) {
  customElements.define("ag-coverflow", AgCoverflow);
}
